import type { FC } from "react";
import type { AddMediaContentProps } from "@/components/MediaSelector/AddMediaModal";
import AddDMSContent from "@/components/MediaSelector/forms/AddDMSContent";
import MediaType from "@/declarations/models/MediaType";

export const AddModel3DMedia: FC<AddMediaContentProps> = ({ value, onCancel, onMediaSaved, ownerId, instanceId }) => (
  <AddDMSContent
    allowedMediaTypes={[MediaType.MODEL_3D]}
    media={value}
    onMediaSaved={onMediaSaved}
    onCancel={onCancel}
    ownerId={ownerId}
    instanceId={instanceId}
  />
);

export default AddModel3DMedia;
